import axios from 'axios'
import { BASE_API, BASE_PATH_API } from './apiConfig'
import { getUserAuth, isValidResponse, isValidResponseExternal } from '../helpers'
import _ from 'lodash'

const getConfig = (configService) => {
	const userAuth = getUserAuth()
	const config = {
		baseURL: BASE_API + BASE_PATH_API,
		headers: {
			Authorization: !_.isEmpty(configService)
				? configService.access_token
				: userAuth?.access_token,
			'Content-Type': 'application/json',
		},
		params: {},
	}
	return config
}

const axiosSuccess = (res) => {
  if (isValidResponse(res?.data)) {
		return res.data
	} else {
		return false
	}
}

const axiosSuccessExternal = (res) => {
  if (isValidResponseExternal(res)) {
		return res.data
	} else {
		return false
	}
}

const axiosError = (error) => {
	return error?.response?.data
}

const axiosService = async (type, url, params, configService) => {
	let config = getConfig(configService)
	switch (type) {
		case 'get':
			return axios.get(url, config).then(axiosSuccess).catch(axiosError)
		case 'post':
			return axios
				.post(url, params, config)
				.then(axiosSuccess)
				.catch(axiosError)
		case 'put':
			return axios.put(url, params, config).then(axiosSuccess).catch(axiosError)
		case 'delete':
			return axios.delete(url, config).then(axiosSuccess).catch(axiosError)
		default:
			return false
	}
}

const axiosServiceExternal = async (type, url, params, configService) => {
	let config = getConfig(configService)
	switch (type) {
		case 'get':
			return axios.get(url, config).then(axiosSuccessExternal).catch(axiosError)
		case 'post':
			return axios
				.post(url, params, config)
				.then(axiosSuccessExternal)
				.catch(axiosError)
		case 'put':
			return axios.put(url, params, config).then(axiosSuccessExternal).catch(axiosError)
		case 'delete':
			return axios.delete(url, config).then(axiosSuccessExternal).catch(axiosError)
		default:
			return false
	}
}

const apiService = (configService = {}) => {
	return {
		get: ({ url, body }) => axiosService('get', url, body, configService),
		post: ({ url, body }) => axiosService('post', url, body, configService),
		put: ({ url, body }) => axiosService('put', url, body, configService),
		delete: ({ url }) => axiosService('delete', url, configService),
	}
}

export const apiServiceExternal = (configService = {}) => {
	return {
		get: ({ url, body }) => axiosServiceExternal('get', url, body, configService),
		post: ({ url, body }) => axiosServiceExternal('post', url, body, configService),
		put: ({ url, body }) => axiosServiceExternal('put', url, body, configService),
		delete: ({ url }) => axiosServiceExternal('delete', url, configService),
	}
}

export const POST = async ({ url, body, headers }) => {
	try {
		const response = await axios.post(url, body, { headers })
		return response.data
	} catch (err) {
		return err?.response?.data
	}
}

export default apiService
